export default function remToPx(rem: number) {
	const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
	return rem * rootFontSize;
}
